const messages = [
  {
    key: 'msgComments',
    title: 'msgComments.title',
    visible: true,
    description: 'msgComments.description',
    links: [
      {
        key: 'link1',
        icon: 'mail',
        label: 'services.help@michelin.com',
        href: 'mailto:services.help@michelin.com',
      },
    ],
  },
];

export default messages;
